import preact from 'preact';
import React from 'react';
import ReactDOM from 'react-dom';
import HomeValueEstimatorRequestFlowModal from './HomeValueEstimatorRequestFlow/HVERequestFormModal';

window.preact = preact;
window.React = React;
window.ReactDOM = ReactDOM;
window.reactComponents = {
    ...window.reactComponents,
    HomeValueEstimatorRequestFlowModal
};
